"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var MILANOM1 = {
  parents: [{
    level: 9,
    slug: 'milano'
  }, {
    level: 118,
    slug: 'metro-m1-linea-rossa-di-milano'
  }]
};
var MILANOM2 = {
  parents: [{
    level: 9,
    slug: 'milano'
  }, {
    level: 118,
    slug: 'metro-m2-linea-verde-di-milano'
  }]
};
var MILANOM3 = {
  parents: [{
    level: 9,
    slug: 'milano'
  }, {
    level: 118,
    slug: 'metro-m3-linea-gialla-di-milano'
  }]
};
var ROMAA = {
  parents: [{
    level: 9,
    slug: 'roma'
  }, {
    level: 118,
    slug: 'metro-linea-a-di-roma'
  }]
};
var NAPOLI2 = {
  parents: [{
    level: 9,
    slug: 'napoli'
  }, {
    level: 118,
    slug: 'metro-linea-2-di-napoli'
  }]
};
var metrostopsSlugList = {
  loreto: {
    parent: {
      metroline: {
        slug: 'metro-m2-linea-verde-di-milano'
      }
    },
    disambiguation: MILANOM1
  },
  'san-babila': {
    parent: {
      metroline: {
        slug: 'metro-m4-linea-blu-di-milano'
      }
    },
    disambiguation: MILANOM1
  },
  duomo: {
    parent: {
      metroline: {
        slug: 'metro-m3-linea-gialla-di-milano'
      }
    },
    disambiguation: MILANOM1
  },
  cadorna: {
    parent: {
      metroline: {
        slug: 'metro-m2-linea-verde-di-milano'
      }
    },
    disambiguation: MILANOM1
  },
  lotto: {
    parent: {
      metroline: {
        slug: 'metro-m5-linea-lilla-di-milano'
      }
    },
    disambiguation: MILANOM1
  },
  'centrale-fs': {
    parent: {
      metroline: {
        slug: 'metro-m3-linea-gialla-di-milano'
      }
    },
    disambiguation: MILANOM2
  },
  'garibaldi-fs': {
    parent: {
      metroline: {
        slug: 'metro-m5-linea-lilla-di-milano'
      }
    },
    disambiguation: MILANOM2
  },
  zara: {
    parent: {
      metroline: {
        slug: 'metro-m5-linea-lilla-di-milano'
      }
    },
    disambiguation: MILANOM3
  },
  termini: {
    parent: {
      metroline: {
        slug: 'metro-linea-b-di-roma'
      }
    },
    disambiguation: ROMAA
  },
  's-giovanni': {
    parent: {
      metroline: {
        slug: 'metro-linea-c-di-roma'
      }
    },
    disambiguation: ROMAA
  },
  mergellina: {
    parent: {
      metroline: {
        slug: 'metro-linea-6-di-napoli'
      }
    },
    disambiguation: NAPOLI2
  }
};

var _default = function _default(locations) {
  if (locations.length === 1 && locations[0].level === 120) {
    var _locations = _slicedToArray(locations, 1),
        loc = _locations[0];

    if (Object.keys(metrostopsSlugList).includes(loc.slug) && loc.parent.metroline.slug === metrostopsSlugList[loc.slug].parent.metroline.slug) {
      var parents = metrostopsSlugList[loc.slug].disambiguation.parents;

      var disambiguated = _objectSpread({}, loc, {
        parents: parents
      });

      return [disambiguated];
    }
  }

  return locations;
};

exports["default"] = _default;